import { typographyClasses as muiTypographyClasses } from '@mui/material';

import type { ThemeOptions, TypographyVariant as MuiTypographyVariant } from '@mui/material';
import type { TypographyVariant } from '../../themes/theme/typography';

type ActiveTypographyPropsVariant = Record<TypographyVariant, true>;
type DisabledTypographyPropsVariant = Record<MuiTypographyVariant, true>; // TODO (@walter-24) Mui Typography variant를 모두 마이그레이션 한 후에 `false`로 변경

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides
    extends ActiveTypographyPropsVariant,
      DisabledTypographyPropsVariant {}
}

export const typographyClasses = muiTypographyClasses;

export const typographyThemes: ThemeOptions['components'] = {
  MuiTypography: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        color: theme.color[ownerState.color as keyof typeof theme.color],
      }),
    },
  },
};
